import { useCallback, type RefObject } from 'react';

export function useFocusableElements(ref: RefObject<HTMLElement | null>) {
    return useCallback((): HTMLElement[] => {
        if (!ref || !ref?.current) {
            return [];
        }
        const focusableSelectors = [
            'button:not([disabled]):not([tabindex="-1"])',
            'input:not([disabled])',
            'textarea:not([disabled])',
            'select:not([disabled])',
            'a[href]',
            '[tabindex]:not([tabindex="-1"])',
        ].join(', ');

        const elements = Array.from(ref.current.querySelectorAll(focusableSelectors)) as HTMLElement[];

        // Sort elements by tabindex to ensure proper tab order
        return elements.sort((a, b) => {
            const aTabIndex = parseInt(a.getAttribute('tabindex') || '0', 10);
            const bTabIndex = parseInt(b.getAttribute('tabindex') || '0', 10);

            // Elements with tabindex 0 should be sorted by their position in DOM
            if (aTabIndex === 0 && bTabIndex === 0) {
                return 0; // Keep original order for elements with tabindex 0
            }

            // Sort by tabindex value
            return aTabIndex - bTabIndex;
        });
    }, [ref]);
}
